<template>
    <DsSelectEmptyState
        icon="fa-regular fa-user-group"
        subtitle="Once added, all clients will be listed here."
        title="No clients added yet"
    >
        <DsButton
            leading="fa-regular fa-user-plus"
            size="sm"
            variant="tertiary"
            @click="$emit('addClients')"
        >
            Add clients
        </DsButton>
    </DsSelectEmptyState>
</template>

<script setup lang="ts">
import DsSelectEmptyState from '@/components/design-system/DsSelectEmptyState.vue';
import DsButton from '@/components/design-system/button/DsButton.vue';

defineEmits<{
    (e: 'addClients'): void;
}>();
</script>
